const emptyString = '';
const period = '.';
// const minus = '-'
// const minusRegExp = /-/
// const nonDigitsRegExp = /\D+/g
// const number = 'number'
const digitRegExp = /\d/;
const caretTrap = '[]';
const removeAllButFirst = (value, char) => {
    const regex = new RegExp(`(?<=(.*${char}.*))${char}`, "g");
    return value.replaceAll(regex, "");
};
const removeAllButLast = (value, char) => {
    const regex = new RegExp(`${char}(?=.*?${char})`, "g");
    return value.replaceAll(regex, "");
};
const removeAll = (value, char) => {
    return value.replaceAll(char, "");
};
function cleanFn(rawValue, options, config) {
    const { decimalSymbol = period, decimalLimit = 2, allowNegative = true, enformceDecimalLimit = false, allowPercent = false } = options || {};
    const currencySymbol = (options.currencySymbol || "").substr(0, 1);
    const allowDecimal = decimalLimit !== 0;
    if (currencySymbol) {
        const currencyIndex = rawValue.indexOf(currencySymbol);
        if (currencyIndex > -1) {
            if (config.currentCaretPosition === 1 && rawValue.substr(1, 1) === currencySymbol && rawValue.substr(0, 1) !== "-") {
                rawValue = rawValue.slice(1);
            }
            rawValue = rawValue.replace(currencySymbol, "");
        }
    }
    rawValue = allowPercent && rawValue.lastIndexOf("%") === rawValue.length - 1 ? removeAllButLast(rawValue, "%") : removeAll(rawValue, "%");
    rawValue = allowNegative && rawValue.indexOf("-") === 0 ? removeAllButFirst(rawValue, "-") : removeAll(rawValue, "-");
    rawValue = allowDecimal ? removeAllButFirst(rawValue, "\\.") : rawValue;
    const regExString = `[\\d${allowNegative ? "-" : ""}${allowDecimal ? decimalSymbol : ""}${allowPercent ? "%" : ""}]`;
    const charTest = new RegExp(regExString);
    let charTobeRemoved = [];
    const chars = rawValue.split("");
    const validChars = chars.filter((c, index) => {
        return charTest.test(c) && !charTobeRemoved.includes(index);
    });
    if (enformceDecimalLimit) {
        charTobeRemoved = [];
        const lastDecimalIndex = validChars.lastIndexOf(".");
        if (lastDecimalIndex > -1) {
            for (let i = lastDecimalIndex + decimalLimit + 1; i < validChars.length; i++) {
                if (validChars[i] === "%")
                    break;
                charTobeRemoved.push(i);
            }
        }
        if (charTobeRemoved.length > 0) {
            for (let i = charTobeRemoved.length - 1; i >= 0; i--)
                validChars.splice(charTobeRemoved[i], 1);
        }
    }
    //Limits the number of decimals
    rawValue = validChars.join("");
    rawValue = removeLeadingZeros(rawValue);
    if (currencySymbol && !rawValue.includes("%") && rawValue) {
        if (rawValue.startsWith("-")) {
            rawValue = rawValue.replace("-", "-" + currencySymbol);
        }
        else {
            if (rawValue !== ".") {
                rawValue = currencySymbol + rawValue;
            }
        }
    }
    return rawValue;
}
export function createNumberMask(options) {
    function numberMask(rawValue = emptyString, config) {
        rawValue = cleanFn(rawValue, options, config);
        const [integer, fraction] = rawValue.split(period);
        const hasPeriod = rawValue.includes(".");
        // integer = addThousandsSeparator(integer);
        let mask = [];
        mask = mask.concat(convertToMask(integer));
        if (hasPeriod) {
            mask = mask.concat([caretTrap, period, caretTrap]);
        }
        if (fraction) {
            mask = mask.concat(convertToMask(fraction));
        }
        // if (rawValue.startsWith("-")) {
        //     mask.splice(2, 0, caretTrap);
        //     // mask.unshift(caretTrap);
        // }
        // console.log(rawValue, mask);
        return mask;
    }
    numberMask.instanceOf = 'createNumberMask';
    function pipe(conformedValue, config) {
        const rawValue = cleanFn(config.rawValue, options, config);
        return rawValue;
        // let [integer, fraction] = rawValue.split(period);
        // const hasPeriod = rawValue.indexOf(period) > -1;
        // integer = addThousandsSeparator(integer);
        // return hasPeriod ? `${integer}.${fraction}` : integer;
    }
    pipe.instanceOf = 'createPipe';
    return [numberMask, pipe];
}
function removeLeadingZeros(value) {
    const negative = value.includes("-") ? "-" : "";
    const percent = value.includes("%") ? "%" : "";
    value = value.replace("-", "").replace("%", "");
    const [integerStr, fractionStr] = value.split(".");
    const integer = integerStr ? addThousandsSeparator(`${parseInt(integerStr)}`) : "";
    const decimal = fractionStr !== undefined ? "." : "";
    const fraction = fractionStr === undefined ? "" : fractionStr;
    return `${negative}${integer}${decimal}${fraction}${percent}`;
}
function convertToMask(strNumber) {
    return strNumber
        .split(emptyString)
        .map((char) => digitRegExp.test(char) ? digitRegExp : char);
}
// http://stackoverflow.com/a/10899795/604296
function addThousandsSeparator(n, thousandsSeparatorSymbol = ",") {
    return n.replace(/\B(?=(\d{3})+(?!\d))/g, thousandsSeparatorSymbol);
}
